import Appsignal from "@appsignal/javascript"

// @ts-expect-error
new Appsignal({ key: import.meta.env.VITE_APPSIGNAL_KEY })
